<template>
  <sidebar-nav>
    <toggle/>
    <menubar-link :to="{name: 'organizations'}">
      <template slot="name">Organizations</template>
      <template slot="icon"><i class="fas fa-sitemap"></i></template>
    </menubar-link>
    <menubar-link :to="{name: 'users'}">
      <template slot="name">Users</template>
      <template slot="icon"><i class="fas fa-users"></i></template>
    </menubar-link>
  </sidebar-nav>
</template>

<script>
import menubarLink from '../common/menubar-link'
import sidebarNav from './sidebar-nav'
import toggle from './toggle'

export default {
  components: {
    menubarLink,
    sidebarNav,
    toggle
  }
}
</script>



// WEBPACK FOOTER //
// src/components/sidebar/owner.vue